import * as Sentry from "@sentry/react";
import { userStatusQueryKey } from "@api/user.api";
import { ACTIVE_USER_ID_KEY } from "@constants";
import { dismissAllToasts } from "@design-system/ToastMessages/useToaster";
import { queryClient } from "../queryClient";
import { safeLocalStorage } from "./storage";

export function clearUser() {
    dismissAllToasts();
    safeLocalStorage.removeItem(ACTIVE_USER_ID_KEY);
    queryClient.setQueryData([userStatusQueryKey], null);
    Sentry.getCurrentScope().setUser(null);
}
